import React, { PureComponent } from 'react';
import FooterModalButton from './FooterModalButton';
// import Sponsor from 'Components/Layout/Sponsor';

const MODAL_NAMES = ['About', 'Methodology', 'FAQ', 'Privacy'];

class Footer extends PureComponent {
  render() {
    const { className } = this.props;
    return (
      <footer className={`Footer ${className ? className : ''}`}>
        {
          // <Sponsor className="Footer-sponsor" />
        }
        <div className="Footer-modal-btn-group">
          {MODAL_NAMES.map((modalName, i) => {
            return <FooterModalButton key={i} modalName={modalName} />;
          })}
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Layout/Footer/index.js